import React, { useMemo } from "react";
import { findUnschedulableItems } from "../../helpers/categorySchedule";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import { FormattedMessage, useIntl } from "react-intl";
import { translatedName } from "../../helpers/translations";

interface IUnavailableItemsWarningMobileProps {
  deliveryTime: Date;
}

function UnavailableItemsWarningMobile({
  deliveryTime,
}: IUnavailableItemsWarningMobileProps) {
  const { categories } = useSelector((state: RootState) => state.menu);
  const { items } = useSelector((state: RootState) => state.cart);
  const { allow_order_when_closed: allowOrderWhenClosed = false } = useSelector(
    (state: RootState) => state.company?.configuration || {}
  );
  const { open: storeOpen } = useSelector(
    (state: RootState) => state.storeTimings
  );

  const unschedulableItems = useMemo(() => {
    if (allowOrderWhenClosed && storeOpen) {
      const currentCartItems = items.length
        ? items
        : JSON.parse(localStorage.getItem("cartItems") || "[]");
      const currentDeliveryTime = deliveryTime || new Date();
      return findUnschedulableItems(currentDeliveryTime, currentCartItems, categories);
    }
    return [];
  }, [allowOrderWhenClosed, storeOpen, deliveryTime, items, categories]);

  const intl = useIntl();

  if (unschedulableItems.length === 0) {
    return null;
  }

  return (
    <div className="unavailable-items-warning-mobile">
      <p>
        <div className="bold-text">
          <FormattedMessage
            id="error.items_unavailable_at_chosen_delivery_time"
            defaultMessage="⚠️ Item(s) unavailable at your chosen delivery time."
          />
        </div>
        <FormattedMessage
          id="error.items_unavailable_at_chosen_time_proceed"
          defaultMessage="To proceed, please consider rescheduling or remove the following item(s):"
        />
      </p>
      <ul>
        {unschedulableItems.map((item: any) => (
          <li key={item.id}>{translatedName(item, intl.locale)}</li>
        ))}
      </ul>
    </div>
  );
}

export default UnavailableItemsWarningMobile;
